import { render, staticRenderFns } from "./organizationType.vue?vue&type=template&id=05a519bc&"
import script from "./organizationType.vue?vue&type=script&lang=js&"
export * from "./organizationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports